export const ADMIN_ROLES = ['master_admin', 'admin', 'support', 'finance'] as const;
export type AdminRole = (typeof ADMIN_ROLES)[number];

export const roleLabel: Record<string, string> = {
  master_admin: 'Master Admin',
  admin: 'Admin',
  support: 'Suporte',
  finance: 'Financeiro',
};

export const roleColor: Record<string, string> = {
  master_admin: 'bg-violet-600/30 text-violet-300',
  admin: 'bg-indigo-600/30 text-indigo-300',
  support: 'bg-cyan-600/30 text-cyan-300',
  finance: 'bg-emerald-600/30 text-emerald-300',
};

export const roleBorderColor: Record<string, string> = {
  master_admin: 'border-violet-500/40',
  admin: 'border-indigo-500/40',
  support: 'border-cyan-500/40',
  finance: 'border-emerald-500/40',
};

export interface AdminRecord {
  roleId: string;
  userId: string;
  role: AdminRole;
  status: string;
  invitedBy: string | null;
  invitedAt: string | null;
  createdAt: string;
  full_name: string;
  first_name: string | null;
  last_name: string | null;
  display_name: string | null;
  email: string;
  phone: string | null;
  cpf: string | null;
  avatar_url: string | null;
  cep: string | null;
  street: string | null;
  street_number: string | null;
  complement: string | null;
  neighborhood: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  last_seen_at: string | null;
  module_permissions: Record<string, boolean> | null;
}
